module.exports = __webpack_public_path__ + "static/media/business-showcase.ad255884.jpg";